/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BoothDto } from '../../models/booth-dto';

export interface FloorPlanControllerFindBoothsByFloorPlanIdV1$Params {
  floorPlanId: string;
}

export function floorPlanControllerFindBoothsByFloorPlanIdV1(http: HttpClient, rootUrl: string, params: FloorPlanControllerFindBoothsByFloorPlanIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BoothDto>>> {
  const rb = new RequestBuilder(rootUrl, floorPlanControllerFindBoothsByFloorPlanIdV1.PATH, 'get');
  if (params) {
    rb.path('floorPlanId', params.floorPlanId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BoothDto>>;
    })
  );
}

floorPlanControllerFindBoothsByFloorPlanIdV1.PATH = '/api/v1/floor-plan/{floorPlanId}/booths';
